/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Empty_BodyInputs */

const en_notes_v2_empty_body = /** @type {(inputs: Notes_V2_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes you capture while listening show up here.`)
};

const es_notes_v2_empty_body = /** @type {(inputs: Notes_V2_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notas que captures mientras escuchas aparecerán aquí.`)
};

/**
* | output |
* | --- |
* | "Notes you capture while listening show up here." |
*
* @param {Notes_V2_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_empty_body = /** @type {((inputs?: Notes_V2_Empty_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Empty_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_empty_body(inputs)
	return en_notes_v2_empty_body(inputs)
});